
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ToggleWsPopupsBtn extends Vue {
  public get enabled(): boolean {
    return !!this.$store.getters.wsPopupsEnabled;
  }

  public toggle(): void {
    this.$store.commit('SET_WS_POPUPS_ENABLED', !this.enabled);
  }
}
